import React from "react";
import {
  InputNumber,
  DatePicker,
  Radio,
  Checkbox,
  Select,
  Input,
  Collapse,
} from "antd";
import moment from "moment";
import "../styles/socialSecurity.css";
import { T } from "antd/lib/upload/utils";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";

const { Option } = Select;
const { Panel } = Collapse;

export const SocialSecurityFormFields = ({
  formFields,
  formData,
  onChange,
}) => {
  // 🔹 Group fields by formGroupName
  const groupedFields =
    formFields &&
    formFields.reduce((acc, field) => {
      if (field.formGroupName && field.formGroupName) {
        if (!acc[field.formGroupName]) acc[field.formGroupName] = [];
        acc[field.formGroupName].push(field);
      } else {
        if (!acc.__ungrouped) acc.__ungrouped = [];
        acc.__ungrouped.push(field);
      }
      return acc;
    }, {});

  // 🔹 Single function to render any field (with your full wrappers preserved)
  const renderField = (field) => {
    const value = formData ? formData[field.name] : null;

    return (
      <div className="social-security-calculator-form-field" key={field.id}>
        <label
          className="social-security-calculator-form-label"
          style={{ display: field.name === "Child Ages" ? "none" : "flex", gap: "3px",alignItems: "baseline" }}
        >
          {field.name} <ToolTipCreator name={field.name} />
        </label>

        {field.dataType === "float" ? (
          <div
            className="social-security-inputWrapper"
            style={{ display: "flex" }}
          >
            {!field.name.includes("%") && (
              <span className="dollarSymbol">$</span>
            )}
            <InputNumber
              className="social-security-calculator-input"
              placeholder={field.name}
              value={value}
              step={1}
              style={{ width: "100%" }}
              formatter={(val) =>
                val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(val) => val.replace(/,/g, "")}
              onChange={(val) => onChange(field.name, val)}
            />
            {field.name.includes("%") && (
              <span className="dollarSymbol">%</span>
            )}
          </div>
        ) : field.dataType === "int" ? (
          <div
            className="social-security-inputWrapper"
            style={{ display: "flex" }}
          >
            <InputNumber
              className="social-security-calculator-input"
              placeholder={field.name}
              value={value}
              style={{ width: "100%" }}
              onChange={(val) => onChange(field.name, val)}
            />
          </div>
        ) : field.dataType === "date" ? (
          <div
            className="social-security-inputWrapper"
            style={{ display: field.name === "Child Ages" ? "none" : "flex" }}
          >
            <DatePicker
              className="social-security-calculator-input"
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "4px",
              }}
              format="MM/DD/YYYY"
              value={
                value
                  ? moment
                      // take only the date part, ignore the UTC time zone
                      .parseZone(value)
                      .utcOffset(0, true)
                  : null
              }
              onChange={(date, dateString) => onChange(field.name, dateString)}
              placeholder={`Select ${field.name}`}
            />
          </div>
        ) : field.dataType === "boolean" ? (
          <Radio.Group
            value={value}
            onChange={(e) => onChange(field.name, e.target.value)}
            optionType="button"
            buttonStyle="solid"
            size="large"
          >
            <Radio.Button value={true}>Yes</Radio.Button>
            <Radio.Button value={false}>No</Radio.Button>
          </Radio.Group>
        ) : field.dataType === "dropdown" ? (
          <Select
            placeholder={`Select ${field.name}`}
            style={{ width: "100%" }}
            value={value}
            onChange={(val) => onChange(field.name, val)}
            allowClear
          >
            {field.attribute_default_values &&
              field.attribute_default_values.map((opt, idx) => (
                <Option key={idx} value={opt.value}>
                  {opt.value}
                </Option>
              ))}
          </Select>
        ) : field.dataType === "string" ? (
          <Input
            className="social-security-calculator-input"
            placeholder={field.name}
            value={value}
            onChange={(e) => onChange(field.name, e.target.value)}
          />
        ) : field.type === "checkbox" ? (
          <Checkbox.Group
            value={value}
            options={field.options && field.options}
            onChange={(val) => onChange(field.name, val)}
            style={{ display: "flex", flexDirection: "column" }}
          />
        ) : null}
      </div>
    );
  };

  return (
    <div className="social-security-calculator-content-form">
      {groupedFields &&
        Object.keys(groupedFields).map((groupKey) => {
          if (groupKey === "__ungrouped") {
            // 🔹 Render ungrouped fields normally
            return groupedFields[groupKey].map((field) => renderField(field));
          }

          // 🔹 Render grouped fields inside Collapse
          return (
            <div
              key={groupKey}
              style={{ flexBasis: "100%", width: "100%", marginBottom: "1rem" }}
            >
              <Collapse
                defaultActiveKey={[groupKey]}
                className="custom-collapse"
              >
                <Panel header={groupKey} key={groupKey}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      flexWrap: "wrap",
                    }}
                  >
                    {groupedFields[groupKey].map((field) => renderField(field))}

                    {/* ✅ Show Child DOB fields inside the "Dependents" group */}
                    {groupKey.toLowerCase() === "dependents" &&
                      formData &&
                      formData["Number of Dependent Children"] > 0 &&
                      Array.from({
                        length: formData["Number of Dependent Children"],
                      }).map((_, idx) => (
                        <div
                          key={idx}
                          className="social-security-inputWrapper"
                          style={{ width: "100%" }}
                        >
                          <label className="social-security-calculator-form-label" style={{display:"flex", alignItems:"baseline", gap:"2px"}}>
                            Child {idx + 1} Date of Birth <ToolTipCreator name={"child_date_of_birth"} />
                          </label>
                          <DatePicker
                            className="social-security-calculator-input"
                            style={{
                              width: "100%",
                              border: "1px solid #d1d5db",
                              borderRadius: "4px",
                            }}
                            format="MM/DD/YYYY"
                            // value={
                            //   formData &&
                            //   formData["Child Ages"] &&
                            //   formData["Child Ages"][idx]
                            //     ? moment(formData["Child Ages"][idx], [
                            //         "MM/DD/YYYY",
                            //         "YYYY-MM-DD",
                            //         moment.ISO_8601,
                            //       ])
                            //     : null
                            // }
                            // onChange={(date, dateString) => {
                            //   const newChildAges = [
                            //     ...(formData["Child Ages"] || []),
                            //   ];
                            //   newChildAges[idx] = dateString || null; // use dateString directly
                            //   onChange("Child Ages", newChildAges);
                            // }}
                            value={
                              formData &&
                              formData["Child Ages"] &&
                              formData["Child Ages"][idx] &&
                              formData["Child Ages"][idx]
                                ? moment
                                    // take only the date part, ignore the UTC time zone
                                    .parseZone(formData["Child Ages"][idx])
                                    .utcOffset(0, true) // keep the date same, don't shift it
                                : null
                            }
                            onChange={(date, dateString) => {
                              const newChildAges = [
                                ...(formData["Child Ages"] || []),
                              ];

                              // ✅ store in a consistent UTC-safe format
                              newChildAges[idx] = date
                                ? moment
                                    .utc(date)
                                    .format("YYYY-MM-DDT00:00:00.000[Z]")
                                : null;

                              onChange("Child Ages", newChildAges);
                            }}
                            placeholder={`Select Child ${idx + 1} DOB`}
                          />
                        </div>
                      ))}
                  </div>
                </Panel>
              </Collapse>
            </div>
          );
        })}
    </div>
  );
};

// import React from "react";
// import { InputNumber, DatePicker, Radio, Checkbox, Select, Input } from "antd";
// import moment from "moment";
// import "../styles/socialSecurity.css";
// const { Option } = Select;

// export const SocialSecurityFormFields = ({
//   formFields,
//   formData,
//   onChange,
// }) => {
//   return (
//     <div className="social-security-calculator-content-form">
//       {formFields &&
//         formFields.map((field) => {
//           const value = formData ? formData[field.name] : null;

//           return (
//             <div
//               className="social-security-calculator-form-field"
//               key={field.id}
//             >
//               <label className="social-security-calculator-form-label">
//                 {field.name}
//               </label>

//               {/* Render by dataType */}
//               {field.dataType === "float" ? (
//                 <div
//                   className="social-security-inputWrapper"
//                   style={{ display: "flex" }}
//                 >
//                   {!field.name.includes("%") && (
//                     <span className="dollarSymbol">$</span>
//                   )}
//                   <InputNumber
//                     className="social-security-calculator-input"
//                     placeholder={field.name}
//                     value={value}
//                     step={1}
//                     style={{ width: "100%" }}
//                     formatter={(val) =>
//                       val
//                         ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
//                         : ""
//                     }
//                     parser={(val) => val.replace(/,/g, "")}
//                     onChange={(val) => onChange(field.name, val)}
//                   />
//                   {field.name.includes("%") && (
//                     <span className="dollarSymbol">%</span>
//                   )}
//                 </div>
//               ) : field.dataType === "int" ? (
//                 <div
//                   className="social-security-inputWrapper"
//                   style={{ display: "flex" }}
//                 >
//                   <InputNumber
//                     className="social-security-calculator-input"
//                     placeholder={field.name}
//                     value={value}
//                     style={{ width: "100%" }}
//                     onChange={(val) => onChange(field.name, val)}
//                   />
//                 </div>
//               ) : field.dataType === "date" ? (
//                 <div
//                   className="social-security-inputWrapper"
//                   style={{ display: "flex" }}
//                 >
//                   <DatePicker
//                     className="social-security-calculator-input"
//                     style={{
//                       width: "100%",
//                       border: "1px solid #d1d5db",
//                       borderRadius: "4px",
//                     }}
//                     format="MM/DD/YYYY"
//                     value={value ? moment(value) : null}
//                     onChange={(date) =>
//                       onChange(
//                         field.name,
//                         date ? date.format("MM/DD/YYYY") : null
//                       )
//                     }
//                     placeholder={`Select ${field.name}`}
//                   />
//                 </div>
//               ) : field.dataType === "boolean" ? (
//                 <Radio.Group
//                   value={value}
//                   onChange={(e) => onChange(field.name, e.target.value)}
//                   optionType="button"
//                   buttonStyle="solid"
//                   size="large"
//                 >
//                   <Radio.Button value={true}>Yes</Radio.Button>
//                   <Radio.Button value={false}>No</Radio.Button>
//                 </Radio.Group>
//               ) : field.dataType === "dropdown" ? (
//                 <Select
//                   placeholder={`Select ${field.name}`}
//                   style={{ width: "100%" }}
//                   value={value}
//                   onChange={(val) => onChange(field.name, val)}
//                   allowClear
//                 >
//                   {field.attribute_default_values &&
//                     field.attribute_default_values.map((opt, idx) => (
//                       <Option key={idx} value={opt.value}>
//                         {opt.value}
//                       </Option>
//                     ))}
//                 </Select>
//               ) : field.dataType === "string" ? (
//                 <Input
//                   className="social-security-calculator-input"
//                   placeholder={field.name}
//                   value={value}
//                   onChange={(e) => onChange(field.name, e.target.value)}
//                 />
//               ) : field.type === "checkbox" ? (
//                 /* Checkboxes */
//                 <Checkbox.Group
//                   value={value}
//                   options={field.options && field.options}
//                   onChange={(val) => onChange(field.name, val)}
//                   style={{ display: "flex", flexDirection: "column" }}
//                 />
//               ) : null}
//             </div>
//           );
//         })}

//       {/* 🔹 Dynamic Child DOB Fields */}
//       {formData &&
//         formData["Number of Dependent Children"] &&
//         formData["Number of Dependent Children"] > 0 &&
//         Array.from({ length: formData["Number of Dependent Children"] }).map(
//           (_, idx) => {
//             const childKey = `childDob${idx + 1}`;
//             return (
//               <div key={childKey} className="social-security-inputWrapper">
//                 <label className="social-security-calculator-form-label">
//                   Child {idx + 1} Date of Birth
//                 </label>
//                 <DatePicker
//                   className="social-security-calculator-input"
//                   style={{
//                     width: "100%",
//                     border: "1px solid #d1d5db",
//                     borderRadius: "4px",
//                   }}
//                   format="MM/DD/YYYY"
//                   value={formData[childKey] ? moment(formData[childKey]) : null}
//                   onChange={(date) =>
//                     onChange(childKey, date ? date.format("MM/DD/YYYY") : null)
//                   }
//                   placeholder={`Select Child ${idx + 1} DOB`}
//                 />
//               </div>
//             );
//           }
//         )}
//     </div>
//   );
// };
